"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const PreferencesIgnoreAndBlock_1 = require("../models/PreferencesIgnoreAndBlock");
class StorageService {
    constructor(namespace, transactionSerializer) {
        this.namespace = namespace;
        this.transactionSerializer = transactionSerializer;
    }
    storeTransactions(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            const storedTransactions = yield this.getTransactions();
            const storedHashIndex = new Map();
            for (const tx of storedTransactions) {
                storedHashIndex.set(tx.hash, true);
            }
            const transactionsToStore = storedTransactions;
            const newStored = [];
            for (const tx of transactions) {
                if (!storedHashIndex.has(tx.hash)) {
                    tx.storedAt = new Date();
                    transactionsToStore.push(tx);
                    newStored.push(tx);
                }
            }
            yield this.replaceAllTransactions(transactionsToStore);
            return newStored;
        });
    }
    storeTransactionSignatures(transaction, signatures) {
        return __awaiter(this, void 0, void 0, function* () {
            const transactions = yield this.getTransactions();
            for (let i = 0; i < transactions.length; i++) {
                if (transactions[i].hash === transaction.hash) {
                    transactions[i].signatures = signatures;
                }
            }
            yield this.replaceAllTransactions(transactions);
        });
    }
    getTransactions() {
        return __awaiter(this, void 0, void 0, function* () {
            const transactionsString = localStorage.getItem(this.namespace + ':' + StorageService.STORAGE_KEY_TRANSACTIONS);
            if (!transactionsString) {
                return [];
            }
            const transactionsData = JSON.parse(transactionsString);
            if (!transactionsData) {
                return [];
            }
            const transactions = [];
            for (const txData of transactionsData) {
                try {
                    transactions.push(this.transactionSerializer.dataToTransaction(txData, true));
                }
                catch (e) {
                    throw new Error('Restoring transaction error: ' + e.message);
                }
            }
            return transactions;
        });
    }
    getPreferencesIgnoreAndBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            const str = localStorage.getItem(this.namespace + ':' + StorageService.STORAGE_KEY_PREFERENCES);
            if (!str) {
                return new PreferencesIgnoreAndBlock_1.PreferencesIgnoreAndBlock([], [], true, false, [], [], true, false);
            }
            return JSON.parse(str);
        });
    }
    storePreferencesIgnoreAndBlock(preferences) {
        return __awaiter(this, void 0, void 0, function* () {
            localStorage.setItem(this.namespace + ':' + StorageService.STORAGE_KEY_PREFERENCES, JSON.stringify(preferences));
        });
    }
    replaceAllTransactions(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            const serialized = [];
            for (const tx of transactions) {
                serialized.push(this.transactionSerializer.transactionToData(tx, true));
            }
            localStorage.setItem(this.namespace + ':' + StorageService.STORAGE_KEY_TRANSACTIONS, JSON.stringify(serialized));
        });
    }
    // noinspection JSUnusedGlobalSymbols
    getUsedStorageSpace() {
        let transactionsSpace = 0;
        const transactionsString = localStorage.getItem(this.namespace + ':' + StorageService.STORAGE_KEY_TRANSACTIONS);
        if (transactionsString) {
            transactionsSpace = new Blob([transactionsString]).size;
        }
        let preferencesSpace = 0;
        const preferencesString = localStorage.getItem(this.namespace + ':' + StorageService.STORAGE_KEY_PREFERENCES);
        if (preferencesString) {
            preferencesSpace = new Blob([preferencesString]).size;
        }
        return transactionsSpace + preferencesSpace;
    }
}
exports.StorageService = StorageService;
StorageService.STORAGE_KEY_TRANSACTIONS = 'transactions';
StorageService.STORAGE_KEY_PREFERENCES = 'preferences';
